<nav class="w3-panel">
  <span *ngFor="let link of router.routerList; first as isFirst">
    <span *ngIf="!isFirst">&nbsp;-&gt;&nbsp;</span> 
    <span>{{ 'breadcrumbs.'+link | translate: session.transparams }}</span>
  </span>
</nav>
